<template>
	<div style="width: 100%;">
		<div style="margin: 6px;">商品设置</div>
		<div class="item">
			<div>{{equipment == 'pc'?'pc端':'移动端'}}每行个数</div>
			<div>
				<wm-input-number
					:value="equipment == 'pc'?this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.pcNum:this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneNum"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="equipment == 'pc'?10:4" @change="changeValue($event)"></wm-input-number>
			</div>
		</div>
		<div class="item" v-if="equipment == 'pc'">
			<div>行边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.rowGap"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.rowGap = e}"></wm-input-number>
			</div>
		</div>
		<div class="item" v-if="equipment == 'pc'">
			<div>列边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.columnGap = e}"></wm-input-number>
			</div>
		</div>
		
		<div class="item" v-if="equipment == 'phone'">
			<div>行边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneRowGap"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneRowGap = e}"></wm-input-number>
			</div>
		</div>
		<div class="item" v-if="equipment == 'phone'">
			<div>列边距</div>
			<div>
				<wm-input-number :value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneColumnGap"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneColumnGap = e}"></wm-input-number>
			</div>
		</div>
		
		
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">显示模式</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode = 'cover'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode == 'cover'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode == 'cover'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode == 'cover'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">裁剪填充</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode = 'contain'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode== 'contain'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode== 'contain'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode== 'contain'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 56px;text-align: center;">
					<span style="scale: 0.85;">原图填充</span>
				</div>
			</div>
		</div>
		
		<div class="item">
			<div>图片宽度</div>
			<div>
				<wm-input-number :value="equipment == 'pc'?selectdItem.compontChildren[0].layoutConfig.goodsConfig.width : selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneWidth"
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100000000000000000000"
					@change="(e)=>{equipment == 'pc'?selectdItem.compontChildren[0].layoutConfig.goodsConfig.width = e : selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneWidth = e}"></wm-input-number>
			</div>
		</div>
		<div class="item">
			<div>图片高度</div>
			<div>
				<wm-input-number :value="equipment == 'pc'?selectdItem.compontChildren[0].layoutConfig.goodsConfig.height : selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneHeight "
					:disabled="false" style="border: solid 1px #959595 ;" :styleObj="{width: '50px',height: '22px'}"
					:step="1" :min="1" :max="100000000000000000000"
					@change="(e)=>{equipment == 'pc'? selectdItem.compontChildren[0].layoutConfig.goodsConfig.height = e : selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneHeight = e}"></wm-input-number>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">标题显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">价格显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">原价显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">悬停边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">悬停边框颜色</div>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.hoverShadowColor"
				style="margin-left: 3px;"></el-color-picker>
		</div>
		<div class="item">
			<div>背景设置</div>
			<div style="display: flex;align-items: center;margin-left:8px;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type = '1'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '1'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '1'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type = '2'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '2'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '2'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 38px;text-align: center;cursor: pointer;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>

		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '1'">
			<div style="width: 68px;">
				背景颜色:
			</div>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.color"></el-color-picker>
		</div>

		<div class="item" v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '2'">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.type == '2'"
				style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
				<div
					style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
					<div style="display: flex;flex-direction: column;">
						<div style="display: flex;align-items: center;">
						</div>
						<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3" placeholder="请输入内容"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.bg.gradientColor">
						</el-input>
					</div>
					<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
						需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
							href="https://www.eggradients.com/">Gradient1</a> <a style="margin-left: 4px;"
							target="_blank" href="https://webgradients.com/">Gradient2</a>
					</div>
				</div>
			</div>
		</div>
		<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">按钮显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">按钮位置</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position = '1'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '1'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '1'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">图上</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position = '2'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '2'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '2'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.position == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">置下</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">鼠标移入再显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.btnHoverShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">加入购物车按钮显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">立即购买按钮显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">收藏按钮显示</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow = true"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">是</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow = false"
					:style="{backgroundColor: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow?'#8c62ff':'#fff',color: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow?'#fff':'#000',border: !selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnShow?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">否</span>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">加入购物车按钮背景</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type = '1'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '1'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '1'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type = '2'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '2'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '2'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>
		
		<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '1'"
			style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
			<div style="width: 68px;">
				背景颜色:
			</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.bgColor"></el-color-picker>
		</div>
		<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.type == '2'"
			style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
			<div
				style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<div style="display: flex;flex-direction: column;">
					<div style="display: flex;align-items: center;">
					</div>
					<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
						placeholder="请输入内容" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartBtnBg.gradientColor">
					</el-input>
				</div>
				<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
					需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
						href="https://www.eggradients.com/">Gradient1</a> <a
						style="margin-left: 4px;" target="_blank"
						href="https://webgradients.com/">Gradient2</a>
				</div>
			</div>
		</div>
		
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">立即购买按钮背景</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type = '1'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '1'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '1'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type = '2'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '2'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '2'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>
		
		<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '1'"
			style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
			<div style="width: 68px;">
				背景颜色:
			</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.bgColor"></el-color-picker>
		</div>
		<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.type == '2'"
			style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
			<div
				style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<div style="display: flex;flex-direction: column;">
					<div style="display: flex;align-items: center;">
					</div>
					<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
						placeholder="请输入内容" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowBtnBg.gradientColor">
					</el-input>
				</div>
				<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
					需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
						href="https://www.eggradients.com/">Gradient1</a> <a
						style="margin-left: 4px;" target="_blank"
						href="https://webgradients.com/">Gradient2</a>
				</div>
			</div>
		</div>
		
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">收藏按钮背景</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type = '1'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '1'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '1'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '1'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">纯色</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type = '2'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '2'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '2'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '2'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">渐变</span>
				</div>
			</div>
		</div>
		
		<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '1'"
			style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
			<div style="width: 68px;">
				背景颜色:
			</div>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.bgColor"></el-color-picker>
		</div>
		<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.type == '2'"
			style="display: flex;align-items: center;padding-left: 4px;margin-top: 6px;justify-content: center;margin-top: 10px;">
			<div
				style="width: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;">
				<div style="display: flex;flex-direction: column;">
					<div style="display: flex;align-items: center;">
					</div>
					<el-input style="width: 172px;margin-top: 4px;" type="textarea" :rows="3"
						placeholder="请输入内容" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeBtnBg.gradientColor">
					</el-input>
				</div>
				<div style="margin-top: 6px;font-size: 12px;color: #55aaff;">
					需要更多模板设置请访问 <a target="_blank" style="margin-left: 4px;"
						href="https://www.eggradients.com/">Gradient1</a> <a
						style="margin-left: 4px;" target="_blank"
						href="https://webgradients.com/">Gradient2</a>
				</div>
			</div>
		</div>
		<!-- <div class="item">
			<div >按钮背景</div>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.bgColor"
				style="margin-left: 3px;"></el-color-picker>
		</div> -->
		
		<div class="item">
			<div >分割线颜色</div>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.rightBorderColor"
				style="margin-left: 3px;"></el-color-picker>
		</div>

		<div style="margin-left: 6px;">加入购物车主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartFamily" placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartColor"
				style="margin-left: 3px;"></el-color-picker>
			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.addCartSize = e}"></wm-input-number>
			</div>
		</div>

		<div style="margin-left: 6px;">立即购买主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowFamily" placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowColor"
				style="margin-left: 3px;"></el-color-picker>
			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.buyNowSize = e}"></wm-input-number>
			</div>
		</div>

		<div style="margin-left: 6px;">收藏主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeFamily" placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeColor"
				style="margin-left: 3px;"></el-color-picker>
			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn.likeSize = e}"></wm-input-number>
			</div>
		</div>


		<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
		</div>

		<div style="margin-left: 6px;">标题主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleFamily" placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleColor"
				style="margin-left: 3px;"></el-color-picker>

			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleSize = e}"></wm-input-number>
			</div>
		</div>

		<div style="margin-left: 6px;">价格主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceFamily"
				placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceColor"
				style="margin-left: 3px;"></el-color-picker>

			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceSize = e}"></wm-input-number>
			</div>
		</div>
		<div style="margin-left: 6px;">原价主题设置</div>
		<div class="item">
			<el-select size="mini" style="width: 100px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceFamily"
				placeholder="选择字体">
				<el-option v-for="(fontItem,index) in fontList" :key="index" :label="fontItem.code"
					:value="fontItem.name">
				</el-option>
			</el-select>
			<el-color-picker size="mini"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceColor"
				style="margin-left: 3px;"></el-color-picker>

			<div style="border: solid 1px #cccccc ;display: flex;align-items: center;padding: 2px;margin-left: 3px;">
				<wm-input-number style="margin-left: 10px;" :iptWidth="30" :disabled="false"
					:styleObj="{width: '30',height: '24px'}" :step="1" :min="1" :max="10000000000"
					:value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceSize"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceSize = e}"></wm-input-number>
			</div>
		</div>

		<!-- <div class="item">
			<div>字体大小</div>
			<div>
				<wm-input-number :disabled="false" :isIcon="true" :styleObj="{width: '136px',height: '32px'}" :step="1"
					:min="1" :max="100000" :value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.size"
					@change="(e)=>{selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.size = e}"></wm-input-number>
			</div>
		</div>

		<div class="item">
			<div>字体斜体</div>
			<el-select size="mini" style="width: 80px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.italic" placeholder="">
				<el-option label="是" :value="true">
				</el-option>
				<el-option label="否" :value="false">
				</el-option>
			</el-select>
		</div>

		<div class="item">
			<div>字体颜色 / 粗细</div>
			<el-color-picker size="mini" style="height: 28px;width: 28px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.color"></el-color-picker>
			<el-select size="mini" style="width: 80px;" v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.weight" placeholder="">
				<el-option v-for="item in fontOptions" :key="item.value" :label="item.label" :value="item.value">
				</el-option>
			</el-select>
		</div>
		
		<div class="item">
			<div>字体类型</div>
			<el-select size="mini" style="width: 130px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.fontFamily" placeholder="">
				<el-option v-for="(fontItem,index) in fontList" :key="index"
					:label="fontItem.code" :value="fontItem.name">
				</el-option>
			</el-select>
		</div> -->
		<div class="item">
			<div>主题悬停颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.titleHoverColor"></el-color-picker>
		</div>
		<div class="item">
			<div>价格悬停颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.discountPriceHoverColor"></el-color-picker>
		</div>
		<div class="item">
			<div>原价悬停颜色</div>
			<el-color-picker size="mini" style="height: 32px;width: 32px;margin-top: 4px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.font.originalPriceHoverColor"></el-color-picker>
		</div>
		<div style="width: 100%;height: 1px;background-color: #c7c7c7;margin: 8px 0px;">
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding" style="margin-top: 10px;">
				<div>内边距</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="paddingSet"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="paddingAll = !paddingAll" :style="{color:paddingAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">组件边框</div>
			<div style="display: flex;align-items: center;margin-left:8px;cursor: pointer;">
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type = ''"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == ''?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == ''?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == ''?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">无</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type = 'solid'"
					:style="{backgroundColor: selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == 'solid'?'#8c62ff':'#fff',color: selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == 'solid'?'#fff':'#000',border: selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type== 'solid'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">实线</span>
				</div>
				<div @click="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type = 'dashed'"
					:style="{backgroundColor:selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == 'dashed'?'#8c62ff':'#fff',color:selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == 'dashed'?'#fff':'#000',border:selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.type == 'dashed'?'solid 1px #8c62ff':'solid 1px #959595' }"
					style="padding: 4px 0px;width: 36px;text-align: center;">
					<span style="scale: 0.85;">虚线</span>
				</div>
			</div>
		</div>

		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;margin-top: 10px;">
			<div style="font-size: 12px;">边框颜色</div>
			<el-color-picker size="mini" style="height: 34px;width: 34px;"
				v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.color"></el-color-picker>
			<el-input size="mini" style="height: 34px;width: 82px;" disabled
				:value="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.color"></el-input>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize"
				style="margin-top: 10px;">
				<div>线条大小</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">顶部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">底部</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerSize"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右侧</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerSizeAll = !borderContainerSizeAll"
							:style="{color:borderContainerSizeAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
		<div style="" class="flex-item-center"
			style="align-items: center;justify-content: space-between;margin: 6px;display: flex;">
			<div style="margin-top: 10px;"
				v-if="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius">
				<div>边框圆角</div>
				<div
					style="display: flex;align-items: center;margin-top: 10px;justify-content: space-between;margin: 6px 0px 6px 6px;">
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[0]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[1]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">右上</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[2]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top:2px;">右下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;">
						<input @input="changeContainerBorderRadius"
							v-model="selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius[3]"
							style="width: 36px;height: 28px;padding: 0px;text-indent:2px;border-radius: 2px;" />
						<div style="margin-top: 2px;">左下</div>
					</div>
					<div style="display: flex;flex-direction: column;align-items: center;margin-left: 4px;">
						<i @click="borderContainerRadiusAll = !borderContainerRadiusAll"
							:style="{color:borderContainerRadiusAll?'#8c62ff':'#000'}"
							style="font-size: 20px;height: 28px;width: 28px;cursor: pointer;"
							class="el-icon-paperclip tit-icon"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import wmInputNumber from '../components/inputNumber.vue'
	export default {
		components: {
			wmInputNumber
		},
		props: {
			goodsData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			equipment: {
				type: String,
				default: "pc"
			},
			fontList: {
				type: Array,
				default: []
			},
			fontFamilyName: {
				type: String,
				default: ""
			},
			selectdItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: "design"
			},
		},
		data() {
			return {
				paddingAll: true,
				fontOptions: [{
						label: '无',
						value: ''
					},
					{
						label: '加粗',
						value: 'bold',
					},
					// {
					// 	label: '100',
					// 	value: '100',
					// },
					// {
					// 	label: '200',
					// 	value: '200',
					// },
					// {
					// 	label: '300',
					// 	value: '300',
					// },
					// {
					// 	label: '400',
					// 	value: '400',
					// },
					// {
					// 	label: '500',
					// 	value: '500',
					// },
					// {
					// 	label: '600',
					// 	value: '600',
					// },
					// {
					// 	label: '700',
					// 	value: '700',
					// },
					// {
					// 	label: '800',
					// 	value: '800',
					// },
					// {
					// 	label: '900',
					// 	value: '900',
					// },
				],
				borderContainerRadiusAll: true,
				borderContainerSizeAll: true,
			}
		},
		watch: {

		},
		mounted() {
			if(!this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.mode) {
				this.$set(this.selectdItem.compontChildren[0].layoutConfig.goodsConfig,'mode','cover')
			}
			
			
			let font = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.font
			let btn = this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.btn
			font.titleFamily = font.titleFamily != '' ? font.titleFamily : this.fontFamilyName
			font.discountPriceFamily = font.discountPriceFamily != '' ? font.discountPriceFamily : this.fontFamilyName
			font.originalPriceFamily = font.originalPriceFamily != '' ? font.originalPriceFamily : this.fontFamilyName

			console.log('mountedmountedbtn',btn)
			btn.addCartFamily = btn.addCartFamily != '' ? btn.addCartFamily : this.fontFamilyName
			btn.buyNowFamily = btn.buyNowFamily != '' ? btn.buyNowFamily : this.fontFamilyName
			btn.likeFamily = btn.likeFamily != '' ? btn.likeFamily : this.fontFamilyName
		},
		methods: {
			paddingSet(e) {
				if (this.paddingAll) {
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding = []
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.padding.push(e.target.value)
				}
			},

			changeValue(e) {
				if (this.equipment == 'pc') {
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.pcNum = e
				} else {
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.phoneNum = e
				}
			},
			changeContainerBorderRadius(e) {
				if (this.borderContainerRadiusAll) {
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius = []
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderRadius.push(e.target.value)
				}
			},
			changeContainerSize(e) {
				if (this.borderContainerSizeAll) {
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize = []
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize.push(e.target.value)
					this.selectdItem.compontChildren[0].layoutConfig.goodsConfig.border.borderSize.push(e.target.value)
				}
			},
		}
	}
</script>

<style scoped lang="scss">
	.item {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin: 6px;
	}

	input:focus {
		outline: none;
		border: 1px solid #242754;
		border-radius: 3px;
	}

	input {
		outline: none;
		border: 1px solid #c1c1c1;
		border-radius: 5px;
	}
</style>